// extracted by mini-css-extract-plugin
export var header = "_gq-0";